function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="110" height="110" fill="none" viewBox="0 0 24 24">
      <path
        fill="#0044F0"
        d="M6.705 12.89a.94.94 0 0 0-.934.948l-.257 4.579a1.2 1.2 0 0 0 1.191 1.208c.658 0 1.19-.54 1.19-1.208l-.256-4.579a.94.94 0 0 0-.934-.947"
        opacity="0.4"
      ></path>
      <path
        fill="#0044F0"
        d="M7.98 3.673s-.268-.275-.434-.395A1.37 1.37 0 0 0 6.712 3c-.333 0-.642.105-.893.302-.046.046-.24.22-.4.383-1.007.952-2.654 3.435-3.157 4.736-.08.197-.251.696-.262.963q0 .382.17.73c.161.29.413.523.71.65.206.082.823.21.835.21.675.128 1.773.196 2.985.196 1.155 0 2.207-.068 2.893-.173.012-.012.777-.139 1.04-.28.48-.254.779-.753.779-1.287v-.046c-.012-.348-.31-1.08-.32-1.08-.504-1.23-2.071-3.655-3.112-4.63"
      ></path>
      <path
        fill="#0044F0"
        d="M17.295 11.11a.94.94 0 0 0 .934-.948l.256-4.579c0-.668-.532-1.208-1.19-1.208a1.2 1.2 0 0 0-1.192 1.208l.258 4.579a.94.94 0 0 0 .934.948"
        opacity="0.4"
      ></path>
      <path
        fill="#0044F0"
        d="M21.829 13.885a1.5 1.5 0 0 0-.71-.65c-.205-.081-.823-.208-.834-.208-.675-.129-1.773-.198-2.985-.198-1.155 0-2.208.07-2.893.174-.012.012-.777.14-1.04.279a1.46 1.46 0 0 0-.78 1.289v.046c.013.348.31 1.078.322 1.078.503 1.23 2.069 3.657 3.11 4.631 0 0 .268.276.434.395.24.186.538.279.836.279.331 0 .64-.105.892-.302.046-.046.24-.22.4-.382 1.005-.953 2.653-3.436 3.155-4.736.081-.197.253-.697.264-.963q0-.383-.171-.732"
      ></path>
    </svg>
  );
}

export default Icon;
